module.exports = __webpack_public_path__ + "static/img/5243_phase_function_Paper_Points.ae67a69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5243_phase_function_Paper_Points.png
// module id = 2Gne
// module chunks = 0